import React from 'react';
import PropTypes from 'prop-types';
const copy = obj => JSON.parse(JSON.stringify(obj));

class JobMilestones extends React.Component {
  state = {
    progress : 0,
  }

  static propTypes = {
    job : PropTypes.object,
    onChange : PropTypes.func,
  }

  handleChange(value) {
    let state = copy(this.props.job);
    state['milestone'] = value;

    if(this.props.onChange) {
      this.props.onChange(state);
    }
  }

  render() {
    const { job } = this.props;
    if(!job) {
      return <noscript />
    }

    const steps = [
      ['Assigned', 'Convert to Prospect'],
      ['Prospect', 'Convert to Job'],
      ['Approved', 'Mark Job Completed'],
      ['Completed', 'Send Invoice'],
      ['Invoiced', 'Close Job'],
      ['Closed']
    ]

    let width = 100 / (steps.length);
    let currentIndex = 0;
    steps.forEach((step, index) => {
      if(job.milestone == step[0]) {
        currentIndex = index;
      }
    });
    let progress_width = 100 - width;
    let progress = (100 / (steps.length - 1)) * currentIndex;

    return (
      <div>
        <div className="wizard-progress">
          <div className="steps-progress" style={{ width : `${progress_width}%`, margin : `0 ${width/2}%`}}>
            <div className="progress-indicator" style={{width: `${progress}%`}}></div>
          </div>
          <ul className="wizard-steps" style={{textAlign : 'justify'}}>
            <li 
            	className={`${job.milestone == 'Assigned' ? 'active' : 'completed'}`} 
            	style={{width : `${width}%`, maxWidth : `none`}}
            	>
              <a onClick={e => {
                e.preventDefault();
              }} href="#"><span>L</span>Lead</a>	
            </li>
            {steps.slice(1,steps.length).map((step, index) => {
              return (
                <li
                  key={index}
                  className={`${job.milestone == step[0] ? 'active' : index < currentIndex ? 'completed' : ''}`}
                  style={{width : `${width}%`, maxWidth : `none`}}
                >
                  <a 
                  	onClick={e => {
                  		e.preventDefault();
                    	this.handleChange.call(this, step[0]);
                  	}} 
                  	href="#"
                  	>
                  	<span>{step[0][0]}</span>{step[0]}
                  </a>
                </li>
              )
            })}
          </ul>
        </div>
        {job.milestone == 'Cancelled' ? (
          <div className="well well-sm danger mb-none">Job Cancelled. 
          	<div 
	          	style={{margin : ` -6px -6px -6px 0px`}} 
	          	onClick={e => this.handleChange.call(this, 'Prospect')} 
	          	className="btn btn-danger pull-right">Reopen Lead <i className="fa fa-sign-in" />
          	</div>
          </div>
        ) : job.milestone == 'Closed' ? (
          <div className="well well-sm success mb-none">Job Closed.</div>
        ) : (
          <div className="well well-sm info mb-none">
            Next Step: {steps[currentIndex][1]}
            {steps[currentIndex][0] == 'Prospect' ? (
              <div 
              	onClick={e => this.handleChange.call(this, 'Cancelled')} 
              	style={{margin : ` -6px -6px -6px 0px`}} 
              	className="pull-right btn btn-warning">
              	<i className="fa fa-window-close-o" /> Cancel Prospect
              </div>
            ) : ''}
            <div 
            	onClick={e => this.handleChange.call(this, steps[currentIndex + 1][0])} 
            	style={{margin : ` -6px 4px`}} 
            	className="pull-right btn btn-default">Complete Stage <i className="fa fa-arrow-right" />
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default JobMilestones;




// WEBPACK FOOTER //
// ./src/browser/components/client/jobs/job-milestones.js